// extracted by mini-css-extract-plugin
export default {"container":"ma","overlay":"na","videoOverlay":"oa","header":"pa","close":"qa","content":"ra"};